// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FCFaHIQ2BwHPCDxOBeRT{margin-left:4px;height:32px;padding-inline:8px;align-items:center;display:flex;color:var(--content-primary-tertiary)}`, "",{"version":3,"sources":["webpack://./src/widgets/Flow/ui/FlowDropdownLabel/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,WAAA,CACA,kBAAA,CACA,kBAAA,CACA,YAAA,CACA,qCAAA","sourcesContent":[".label {\n  margin-left: 4px;\n  height: 32px;\n  padding-inline: 8px;\n  align-items: center;\n  display: flex;\n  color: var(--content-primary-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `FCFaHIQ2BwHPCDxOBeRT`
};
export default ___CSS_LOADER_EXPORT___;
